import { render } from "./FeedNavigationMenu.vue?vue&type=template&id=3e232abe&scoped=true&lang=html"
import script from "./FeedNavigationMenu.vue?vue&type=script&lang=js"
export * from "./FeedNavigationMenu.vue?vue&type=script&lang=js"

import "./FeedNavigationMenu.vue?vue&type=style&index=0&id=3e232abe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3e232abe"

export default script